import "./generated-1784537122.css";

const navigation = ["과제", "직보자료", "질문", "선생님 공지", "알림", "마이페이지"];
const lessons = [
  ["1강: 함수의 극한", "complete"],
  ["2강 : 극한의 성질과 계산", "complete"],
  ["3강 : 극한의 성질과 계산", "complete"],
  ["4강 : 도함수의 활용", "current"],
  ["5강 : 도함수의 그래프 활용", "locked"],
  ["6강 : 부정적분 기초", "locked"],
  ["7강 : 부정적분 기초", "locked"],
  ["8강 : 정적분과 넓이", "locked"],
] as const;

function Gem({ purple = false }: { purple?: boolean }) {
  return <span className={`g7122-gem ${purple ? "purple" : ""}`}><b>3</b></span>;
}

export default function Generated1784537122() {
  return <main className="g7122-page">
    <aside className="g7122-sidebar">
      <div className="g7122-logo">내신인강</div>
      <button className="g7122-term">2학년 1학기 중간 <span>⌄</span></button>
      <nav>
        <a className="selected"><i>◆</i>나의 학습</a>
        {navigation.map(item => <a key={item}>{item}<em>2</em></a>)}
      </nav>
    </aside>

    <section className="g7122-content">
      <div className="g7122-inner">
        <header className="g7122-student">
          <div><span className="g7122-avatar"/><h1>이하은 학생</h1><p>이화여자 강남 세화고등학교</p></div>
          <button>담당 : 한상우 선생님 <span>⌄</span></button>
        </header>

        <section className="g7122-rewards">
          <div className="g7122-streak"><span className="g7122-medal">3</span><div><strong>연속 출석 3일 달성 <i>////</i></strong><small>4일만 꾸준히 출석하면&nbsp; 위클리 엠블럼 획득가능</small></div></div>
          <div className="g7122-reward"><Gem/><div><strong>진도 보상</strong><small>3일 연속</small></div><b>›</b></div>
          <div className="g7122-reward last"><Gem purple/><div><strong>과제 보상</strong><small>3일 연속</small></div></div>
        </section>

        <section className="g7122-block g7122-exam"><h2>시험 정보</h2><div className="g7122-exam-row">
          <div><small>부교재</small><p>쎈 수학Ⅰ + 자이스토리</p></div><div><small>시험 기간</small><p>26.06.24 ~ 26.06.27</p></div><div><small>시험 범위</small><p>함수의 극한과 연속 ~ 도함수의 활용 (접선의 방정식 또는 평균값 정리까지)</p></div>
        </div></section>

        <section className="g7122-block"><h2>전체 학습 진도</h2><div className="g7122-lessons">
          {lessons.map(([title, state], index) => <article className={`g7122-lesson ${state}`} key={title}>
            <span className="g7122-number">{index + 1}</span><div className="g7122-lesson-copy"><strong>{title}</strong>{state !== "locked" && <div className="g7122-progress"><i/><span>{state === "current" ? "74%" : "100%"}</span></div>}</div>
            {state !== "locked" && <div className="g7122-state"><small>업로드 대기</small><b>{state === "current" ? "시청 중" : "과제 제출 필요"}</b></div>}
          </article>)}
        </div></section>
      </div>
    </section>
    <button className="g7122-chat"><span>▱</span> 채팅하기</button>
  </main>;
}
